import { Chip, styled } from '@mui/material';

interface StatusChipProps {
  status: boolean;
}

export const StatusChip = styled(Chip)<StatusChipProps>`
  background-color: ${({ theme, status }) =>
    status == 'unknown'
      ? theme.palette.grey['02']
      : status == 'online'
        ? theme.palette.status.online
        : theme.palette.status.offline};
  color: ${({ theme, status }) =>
    status ? theme.palette.white['01'] : 'outlined'};
  height: 28px;
`;

export const MainHeader = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;

  .divHeader {
    display: flex;
    flex-direction: row;
    align-content: center;
    gap: 12px;
  }
`;

export const DescriptionComponent = styled('div')`
  padding: 8px 8px;
  background-color: ${({ theme }) => theme.palette.grey['03'] + '90'};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey['05']};
  margin-bottom: 8px;
  font-size: 12px;
`;
